import type { AdminClientSummary } from '../../clients/index.js'
import { Check } from 'lucide-react'
import { Modal } from '../../core/index.js'
import { Button } from '../../core/index.js'
import { DetailFields, DetailSection, type DetailField } from '../../core/index.js'

interface AccountDetailModalProps {
  /** What kind of login this is, e.g. "Operator". */
  kind: string
  name: string
  /** What is specific to this account: its id, login email, what it can reach. */
  fields: readonly DetailField[]
  /** The client the account signs in to. */
  client: AdminClientSummary
  onClose: () => void
}

/** One sign-in account - an operator or a facility administrator - with the client it belongs to. */
export function AccountDetailModal({ kind, name, fields, client, onClose }: AccountDetailModalProps) {
  return (
    <Modal
      eyebrow={kind}
      title={name}
      subtitle={client.organizationName}
      onClose={onClose}
      footer={
        <Button icon={Check} autoFocus onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="flex flex-col gap-6 bg-canvas p-6">
        <DetailSection title="Account">
          <DetailFields fields={fields} />
        </DetailSection>
        <DetailSection title="Client">
          <DetailFields
            fields={[
              { label: 'Organization', value: client.organizationName },
              { label: 'Application', value: client.applicationName },
              { label: 'Client ID', value: client.clientId ?? 'Not issued yet', mono: true },
              { label: 'Environment', value: <span className="capitalize">{client.environment}</span> },
              { label: 'Status', value: <span className="capitalize">{client.status}</span> },
              { label: 'Facilities', value: (client.facilityCount ?? 0).toLocaleString() },
              { label: 'Workers', value: (client.workerCount ?? 0).toLocaleString() },
              { label: 'API scopes', value: client.scopes?.join(', ') ?? 'Not reported', mono: true },
              { label: 'Contact', value: client.contactEmail },
            ]}
          />
        </DetailSection>
      </div>
    </Modal>
  )
}
